import { supabase } from './supabase';

/** Normalize bookings.media from PostgREST (array, string, null). */
export function normalizeBookingMedia(media) {
  if (!media) return [];
  if (Array.isArray(media)) return media.filter(Boolean);
  if (typeof media === 'string') {
    try {
      const parsed = JSON.parse(media);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch {
      return [];
    }
  }
  return [];
}

export function mediaCountFrom(row) {
  return normalizeBookingMedia(row?.media).length;
}

/** Load a private storage object for staff/customer session. */
export async function resolveMediaObject(item) {
  const bucket = item.bucket || 'vehicle-photos';
  const path = item.path;
  if (!path) {
    return { url: item.url || null, revoke: false, error: 'Missing path' };
  }

  const signed = await supabase.storage.from(bucket).createSignedUrl(path, 60 * 60);
  if (!signed.error && signed.data?.signedUrl) {
    return { url: signed.data.signedUrl, revoke: false, error: null };
  }

  const downloaded = await supabase.storage.from(bucket).download(path);
  if (!downloaded.error && downloaded.data) {
    return {
      url: URL.createObjectURL(downloaded.data),
      revoke: true,
      error: null,
    };
  }

  return {
    url: null,
    revoke: false,
    error: downloaded.error?.message || signed.error?.message || 'Could not open file',
  };
}

export function kindFromName(name = '') {
  const ext = name.split('.').pop()?.toLowerCase() || '';
  if (['mp4', 'mov', 'm4v', 'webm'].includes(ext)) return 'video';
  if (['m4a', 'aac', 'mp3', 'wav', 'ogg'].includes(ext)) return 'audio';
  if (['jpg', 'jpeg', 'png', 'webp', 'heic', 'heif', 'gif'].includes(ext)) {
    return 'photo';
  }
  return 'file';
}
